<template>
  <div class="msg-persistent" v-if="actMenu">
    <div class="msg-persistent__row msg-persistent__row-input">
      <sw-button :label="$t('view.settings.statics.disableInput')" v-model="actMenu.data.composer_input_disabled"></sw-button>
    </div>
    <div class="msg-persistent__btns">
      <div class="msg-persistent__row msg-persistent__btn-row msg-persistent__btn-row-exist"
        v-for="(item, index) in actMenu.data.call_to_actions"
        :key="index">
        <in class="msg-persistent__item-first" :label="$t('common.title')" v-model="item.title"/>
        <in class="msg-persistent__item-second" :label="$t('common.url')" v-model="item.url" v-if="item.type === 'web_url'"/>
        <sel class="msg-persistent__item-second" v-else
          v-model="item.payload"
          :label="$t('common.target')">
          <optgroup v-for="group in $store.state.flowGroups" :key="group.id" :label="group.name">
            <option
              v-for="block in group.blocks"
              :key="block.id"
              :value="'POWERBOT_REDIRECT_TO:'+block.uuid"
            >{{ block.name }}</option>
          </optgroup>
        </sel>
        <sel class="msg-persistent__item-third" 
          v-model="item.type" 
          :label="$t('common.type')"
          @change="typeChanged(item)">
          <option value="postback">Payload</option>
          <option value="web_url">Web url</option>
        </sel>
        <div class="msg-persistent__item-del">
          <fai icon="ban" @click="deleteBtn(index)" v-if="index>0"/>
        </div>
      </div>
      <div class="msg-persistent__row msg-persistent__btn-row msg-persistent__btn-row-add"
        v-if="actMenu.data.call_to_actions.length<3"
        @click="addTemplateBtn">
        <fai icon="plus"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      actMenu: null
    }
  },

  props: {
    menu: Object
  },

  watch: {
    menu () {
      this.actMenu = this.menu
    }
  },

  mounted () {
    this.actMenu = this.menu
  },

  methods: {
    typeChanged (item) {
      if(item.type === 'postback') {
        delete item.url
        item.payload = ''
      } else {
        delete item.payload
        item.url = ''
      }
    },

    deleteBtn (index) {
      this.actMenu.data.call_to_actions.splice(index, 1)
    },

    addTemplateBtn () {
      this.actMenu.data.call_to_actions.push({
        payload: '',
        title: '',
        type: 'postback'
      })
    }
    
  }
}
</script>

<style lang="scss">
.msg-persistent {

  &__row {
    padding: 0px 10px;
    background: $bgLightGrey;
  }

  &__row-input {
    padding-top: 10px;
    padding-bottom: 10px;
  }

  &__btn-row {
    padding-top: 10px;
    padding-bottom: 10px;
    margin-top: 2px;
  }

  &__btn-row-exist {
    display: flex;
    justify-content: space-between;
  }

  &__item-first {
    width: 30%;
  }

  &__item-second {
    width: 30%;
  }

  &__item-third {
    width: 30%;
  }

  &__item-del {
    cursor: pointer;
    width: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.2em;
  }

  &__btn-row-add {
    cursor: pointer;
    display: flex;
    justify-content: center;
  }
}
</style>
